/**
 * @deprecated Use `RecurrenceFrequency`.
 */
export enum ReminderRecurrenceFrequency {
  /**
   * @deprecated Use `RecurrenceFrequency.DAILY`.
   */
  DAILY,
  /**
   * @deprecated Use `RecurrenceFrequency.WEEKLY`.
   */
  WEEKLY,
  /**
   * @deprecated Use `RecurrenceFrequency.MONTHLY`.
   */
  MONTHLY,
  /**
   * @deprecated Use `RecurrenceFrequency.YEARLY`.
   */
  YEARLY,
}
